// screens/approvalPendingPage/ApprovalPendingPage.jsx

import React from 'react';
import { Layout, Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const ApprovalPendingPage = () => {
    const navigate = useNavigate();

    const handleContactSupport = () => {
        window.location.href = 'mailto:support@enablesend.com';
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px' }}>
                <div style={{ maxWidth: '600px', textAlign: 'center' }}>
                    <Title level={2}>Application Under Review</Title>
                    <Paragraph>
                        Your application is currently under review. We will notify you once it's approved.
                    </Paragraph>
                    <Paragraph>
                        If you have any questions or need further assistance, please contact us at
                        <a href="mailto:customerservices@enable-send.co.uk"> customerservices@enablesend.co.uk</a>.
                    </Paragraph>
                    {/* <Button type="primary" onClick={handleContactSupport}>
                        Contact Support
                    </Button> */}
                    <br />
                    <Button type="primary" style = {{marginTop: '15px'}}href ="/">
                        Go back to home
                    </Button>
                </div>
            </Content>
        </Layout>
    );
};

export default ApprovalPendingPage;
